// Global modal som vises når backend returnerer creator_access_expired (402).
// Lytter på "ne:creator-expired"-event fra api.js.
import React, { useEffect, useState } from "react";
import { X, ExternalLink } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function CreatorExpiredModal() {
  const [state, setState] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const on = (e) => setState(e.detail || { message: "Skaper-abo er utløpt." });
    window.addEventListener("ne:creator-expired", on);
    return () => window.removeEventListener("ne:creator-expired", on);
  }, []);

  if (!state) return null;

  const buy = () => {
    navigate(state.buyUrl || "/kjop-vip");
    setState(null);
  };

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/85 flex items-center justify-center p-4"
      onClick={() => setState(null)}
      data-testid="creator-expired-modal"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-[var(--noir-elev)] border border-[var(--magenta)]/40 max-w-md w-full p-6"
      >
        <div className="flex justify-between items-start mb-4">
          <h3 className="font-fraunces italic text-xl text-[var(--cream)]">Skaper-abo utløpt</h3>
          <button onClick={() => setState(null)} data-testid="creator-expired-close">
            <X className="w-5 h-5 text-[var(--cream-soft)]" />
          </button>
        </div>
        <p className="text-sm text-[var(--cream-soft)] mb-6">
          {state.message || "Du har mistet tilgang til skaperstudio og skaperprofil-redigering. Kjøp abo for å beholde tilgangen."}
        </p>
        <button
          onClick={buy}
          className="btn-magenta w-full flex items-center justify-center gap-2"
          data-testid="creator-expired-buy"
        >
          <ExternalLink className="w-4 h-4" /> KJØP SKAPER-ABO
        </button>
        <p className="text-[10px] text-[var(--cream-faint)] mt-3 text-center">
          Ingen forpliktelser. Kjøp én måned om gangen via Strex eller krypto.
        </p>
      </div>
    </div>
  );
}
